export default "__VITE_ASSET__LLiwj5m5__"